import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { NotFoundComponent } from './shared/components/not-found/not-found.component';
import { AuthGuard } from './guards/auth.guard';
//fcuadros
import { OrderSalesRoutingModule } from "./components/ordersales-gcv/ordersales.routing";
import { ClientsRoutingModule } from './components/clients/clients.routing';
import { LoginComponent } from './components/login/login.component';
import { ModelsRoutingModule } from './components/models/models.routing';
import { TemplateRoutingModule } from './components/template/template.routing';
import { CacRoutingModule } from './components/cac/cac.routing';
import { RptRoutingModule } from './components/reports/reports.routing';
import { OrderSalesFisicaRoutingModule } from './components/ordersales-gcf/ordersales.fisica.routing';
import { OrderSalesTiendaRoutingModule } from './components/ordersales-tv/ordersalestienda.routing';

@NgModule({
  imports: [
    RouterModule.forRoot([     
      { path: '', redirectTo: 'home', pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'home', component: HomeComponent, canActivate: [AuthGuard] },
      { path: 'login', component: LoginComponent, canActivate: [AuthGuard]},
      //{ path: 'unauthorized', component: UnauthorizedComponent },
      { path: "**", component: NotFoundComponent, data: { title: "Page Not Found" } },
    ]),
    OrderSalesRoutingModule,
    OrderSalesFisicaRoutingModule,
    OrderSalesTiendaRoutingModule,
    ClientsRoutingModule,
    ModelsRoutingModule,
    TemplateRoutingModule,
    CacRoutingModule,
    RptRoutingModule
  ],
  exports: [
    RouterModule
  ],
  providers: []
})
export class AppRoutingModule { }

